import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { CompanyToken } from '../../../models/company.model';
import { AppServiceToken } from '../../../models/app.service.model';
import { Settings } from '../../../models/settings.model';

export interface PayrollPageProps {}

type ContextType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: CompanyToken | null,
  appServiceForUser: AppServiceToken | null,
  settingsForCompany: Settings | null
};

const PayrollPage: React.FunctionComponent<PayrollPageProps> = () => {
  const { setRoute, companyForUser, appServiceForUser, settingsForCompany } = UseOutletContext();

  return (
    <Outlet context={{ setRoute, companyForUser, appServiceForUser, settingsForCompany }} />
  );
};

export function UseOutletContextPayroll() {
  return useOutletContext<ContextType>();
}

export default PayrollPage;
